<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitle">CONTENTS</h1>
<h2 class="toc1"><a href="#/xhtml/04_Note">Note</a></h2>
<h2 class="toc2"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc2"><a href="#/xhtml/06_Glossary">Glossary</a></h2>
<h2 class="toc3"><a href="#/xhtml/07_Brief">Brief Background</a></h2>
<h2 class="toc2"><a href="#/xhtml/08_Opor">OPOR HOREV</a></h2>
<h2 class="toc2"><a href="#/xhtml/10_Chapter_001">Day 0: 22 December 1948</a></h2>
<h2 class="toc"><a href="#/xhtml/11_Chapter_002">Day 1: 23 December 1948</a></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter_003" title="Link target outside of Sample">Day 2: 24 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter_004" title="Link target outside of Sample">Day 3: 25 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter_005" title="Link target outside of Sample">Day 4: 26 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter_006" title="Link target outside of Sample">Day 5: 27 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter_007" title="Link target outside of Sample">Day 6: 28 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter_008" title="Link target outside of Sample">Day 7: 29 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter_009" title="Link target outside of Sample">Day 8: 30 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter_010" title="Link target outside of Sample">Day 9: 31 December 1948</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter_011" title="Link target outside of Sample">Day 10: 1 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter_012" title="Link target outside of Sample">Day 11: 2 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter_013" title="Link target outside of Sample">Day 12: 3 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter_014" title="Link target outside of Sample">Day 13: 4 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter_015" title="Link target outside of Sample">Day 14: 5 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Chapter_016" title="Link target outside of Sample">Day 15: 6 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/26_Chapter_017" title="Link target outside of Sample">Day 16: 7 January 1949</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Chapter_0E1" title="Link target outside of Sample">Ceasefire</span></h2>
<h2 class="toc4"><span href="#/xhtml/28_Chapter_0E2" title="Link target outside of Sample">End of OPOR HOREV</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0fa005ba